import {
  faBars,
  faBarsStaggered,
  faRightFromBracket,
  faIdCard,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch } from "../../app/hooks";
import { useAppSelector } from "../../app/hooks";
import { setNavbar, setWidgetExpand } from "../../state/layoutSlice";
import { selectIsNavbar } from "../../selectors/layoutSelectors";
import "./header.scss";
import { useMutation } from "react-query";
import { createAction } from "@reduxjs/toolkit";
import { useNavigate } from "react-router";
import imageForRole from "../../helpers/imageForRole";
import { Link } from "react-router-dom";
import { logout } from "services/auth-service";
import Cookies from "js-cookie";

const logoutAction = createAction("logout");

const Header = () => {
  const avatar = localStorage.getItem("avatar");
  const isNavbar = useAppSelector(selectIsNavbar);
  const dispatch = useAppDispatch();
  const logoutMutation = useMutation(logout);
  const navigate = useNavigate();

  const toggleNavbar = () => {
    dispatch(setNavbar(!isNavbar));
    dispatch(setWidgetExpand(false));
  };

  const logOut = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      logoutMutation.mutate(token, {
        onSuccess: (res) => {
          if (res.success) {
            Cookies.remove("token", {
              domain: ".digital.trccompanies.com",
            });
            localStorage.clear();
            dispatch(logoutAction());
            navigate("/auth/login");
          }
        },
      });
    }
  };

  return (
    <header className="page_header fixed-top d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-between">
        <Link to="/" className="applogo d-flex align-items-center">
          <img src={require("../../assets/img/logo.png")} alt="logo" />
        </Link>
        <span
          onClick={toggleNavbar}
          title={isNavbar ? "Hide Sidebar" : "Show Sidebar"}
        >
          <FontAwesomeIcon
            icon={isNavbar ? faBarsStaggered : faBars}
            size="lg"
            style={{ color: "#1673E8", cursor: "pointer" }}
            className="mx-3"
          />
        </span>
      </div>

      <nav className="header-nav ms-auto" data-spy="affix">
        <ul className="d-flex align-items-center">
          <li className="nav-item dropdown pe-3">
            <div
              className="nav-link d-flex align-items-center pe-0"
              data-bs-toggle="dropdown"
            >
              <img
                alt="profile"
                src={avatar ? avatar : imageForRole()}
                className="avatar avatar-sm avatar-online rounded-circle c-pointer"
              />
            </div>
            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
              <li className="my-1">
                <Link
                  to="/account"
                  className="dropdown-item d-flex align-items-center"
                >
                  <FontAwesomeIcon
                    icon={faIdCard}
                    style={{ color: "#9A99A2" }}
                    className="me-2"
                  />
                  <span>My Account</span>
                </Link>
              </li>
              {/* <li>
                                <Link to="/settings" className="dropdown-item d-flex align-items-center" >
                                    <FontAwesomeIcon icon={faCogs} style={{ color: "#9A99A2" }} className="me-2" />
                                    <span>Account Settings</span>
                                </Link>
                            </li> */}
              <div className="dropdown-divider"></div>
              <li onClick={logOut} style={{ cursor: "pointer" }}>
                <div className="dropdown-item d-flex align-items-end">
                  <FontAwesomeIcon
                    icon={faRightFromBracket}
                    style={{ color: "#9A99A2" }}
                    className="me-2"
                  />
                  <span>Logout</span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
